import { STATUS, PRODUCT_CATEGORIES, ARTICLE_CATEGORIES } from "../../lib/content";

const FORMAT_HINT = "Leave a blank line between paragraphs. Start a line with '## ' for a heading, '- ' for a bullet point, and write links as [text](https://...).";

export const SCHEMAS = {
  products: {
    label: "Products",
    singular: "product",
    titleKey: "name",
    imageKey: "image",
    fields: [
      { key: "name", label: "Product name", type: "text", required: true },
      { key: "tagline", label: "Tagline", type: "text" },
      { key: "status", label: "Status", type: "select", options: Object.entries(STATUS).filter(([value]) => value !== "coming_soon").map(([value, v]) => ({ value, label: v.label })) },
      { key: "category", label: "Category", type: "combo", options: PRODUCT_CATEGORIES },
      { key: "summary", label: "Short summary (shown on cards)", type: "textarea", rows: 3 },
      { key: "description", label: "Full description", type: "longtext", hint: FORMAT_HINT },
      { key: "targets", label: "Targets & uses (pests, crops) – comma separated", type: "tags" },
      { key: "image", label: "Main image", type: "image" },
      { key: "attachments", label: "Documents (datasheets, PDFs)", type: "files" },
      { key: "order", label: "Display order (lower shows first)", type: "number" },
      { key: "published", label: "Published on website", type: "switch" },
    ],
    defaults: { name: "", tagline: "", status: "in_development", category: "Biological control", summary: "", description: "", targets: [], image: "", attachments: [], order: 10, published: true },
  },
  services: {
    label: "Consulting",
    singular: "service",
    titleKey: "title",
    imageKey: "image",
    fields: [
      { key: "title", label: "Service title", type: "text", required: true },
      { key: "summary", label: "Summary", type: "textarea", rows: 3 },
      { key: "description", label: "Description", type: "textarea", rows: 5 },
      { key: "deliverables", label: "Deliverables – comma separated", type: "tags" },
      { key: "image", label: "Image", type: "image" },
      { key: "order", label: "Display order (lower shows first)", type: "number" },
      { key: "published", label: "Published on website", type: "switch" },
    ],
    defaults: { title: "", summary: "", description: "", deliverables: [], image: "", order: 10, published: true },
  },
  articles: {
    label: "Insights & news",
    singular: "article",
    titleKey: "title",
    imageKey: "cover_image",
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "excerpt", label: "Excerpt (shown on cards)", type: "textarea", rows: 3 },
      { key: "body", label: "Article body", type: "longtext", hint: FORMAT_HINT },
      { key: "category", label: "Topic", type: "select", options: ARTICLE_CATEGORIES.map((c) => ({ value: c, label: c })) },
      { key: "cover_image", label: "Cover image", type: "image" },
      { key: "attachments", label: "Downloads (PDF reports, factsheets)", type: "files" },
      { key: "source_url", label: "Original source link (optional)", type: "text", placeholder: "https://" },
      { key: "author", label: "Author", type: "text" },
      { key: "read_minutes", label: "Reading time (minutes)", type: "number" },
      { key: "published_at", label: "Publish date", type: "date" },
      { key: "published", label: "Published on website", type: "switch" },
    ],
    defaults: { title: "", excerpt: "", body: "", category: "Innovation", audience: [], cover_image: "", attachments: [], source_url: "", author: "Bio Smart Solutions", read_minutes: 5, published_at: null, published: true },
  },
};
